import { useState } from "react";
import { Copy, Check } from "lucide-react";

// A multi-line snippet with its own copy button. A snippet is pasted into HTML,
// so it is shown as a block and must survive copying with its newlines intact.
export default function CodeSnippet({ label, code }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      window.prompt("Copy this snippet", code);
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] font-bold uppercase tracking-wide text-(--text-muted)">
          {label}
        </span>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 rounded-(--radius-sm) border border-(--border-subtle) bg-(--surface-2) px-2 py-1 text-xs text-(--text-secondary) transition-colors hover:bg-(--surface-muted)"
          title="Copy snippet"
          aria-label={`Copy ${label} snippet`}
        >
          {copied ? (
            <>
              <Check size={13} className="text-(--status-success)" /> Copied
            </>
          ) : (
            <>
              <Copy size={13} /> Copy
            </>
          )}
        </button>
      </div>
      <pre className="overflow-x-auto rounded-(--radius-sm) bg-(--surface-2) px-3 py-2 text-xs leading-relaxed text-(--text-primary)">
        <code>{code}</code>
      </pre>
    </div>
  );
}
